import React from "react";
import {
  Box,
  TextField,
  Typography,
  Paper,
  IconButton,
} from "@mui/material";
import { Add as AddIcon } from "@mui/icons-material";
import FormField from "./form-field"; // Keep using your existing FormField component

export default function FormCanvas({
  form,
  onUpdateForm,
  onUpdateField,
  onDeleteField,
  selectedField,
  onSelectField,
}) {
  const handleTitleChange = (e) => {
    onUpdateForm({ title: e.target.value });
  };

  const handleDescriptionChange = (e) => {
    onUpdateForm({ description: e.target.value });
  };

  const handleFieldClick = (field) => {
    onSelectField(selectedField?.id === field.id ? null : field);
  };

  return (
    <Box
      sx={{
        flex: 1,
        bgcolor: "#f9fafb",
        p: 3,
        minHeight: "100vh",
      }}
      data-testid="form-canvas"
    >
      <Box sx={{ maxWidth: "64rem", mx: "auto" }}>
        {/* Form Header */}
        <Paper
          elevation={1}
          sx={{
            p: 3,
            mb: 3,
            border: "1px solid #e5e7eb",
            borderRadius: 2,
          }}
        >
          <TextField
            variant="standard"
            placeholder="Untitled Form"
            value={form.title || ""}
            onChange={handleTitleChange}
            fullWidth
            inputProps={{
              style: {
                fontSize: "1.5rem",
                fontWeight: "bold",
              },
            }}
            data-testid="input-form-title"
          />
          <TextField
            variant="standard"
            placeholder="Form description..."
            value={form.description || ""}
            onChange={handleDescriptionChange}
            fullWidth
            multiline
            rows={2}
            sx={{ mt: 1 }}
            data-testid="textarea-form-description"
          />
        </Paper>

        {/* Form Builder Drop Zone */}
        <Paper
          elevation={1}
          sx={{
            border: "1px solid #e5e7eb",
            borderRadius: 2,
            minHeight: "24rem",
          }}
          data-testid="form-drop-zone"
        >
          {form.fields && form.fields.length > 0 ? (
            <Box>
              {form.fields
                .sort((a, b) => a.order - b.order)
                .map((field) => (
                  <Box
                    key={field.id}
                    sx={{
                      borderBottom: "1px solid #f3f4f6",
                      bgcolor:
                        selectedField?.id === field.id
                          ? "#e3f2fd"
                          : "transparent",
                      boxShadow:
                        selectedField?.id === field.id
                          ? "inset 0 0 0 2px #1976d2"
                          : "none",
                      "&:hover": {
                        bgcolor:
                          selectedField?.id === field.id
                            ? "#e3f2fd"
                            : "#f9fafb",
                      },
                    }}
                  >
                    <FormField
                      field={field}
                      isSelected={selectedField?.id === field.id}
                      onClick={() => handleFieldClick(field)}
                      onUpdate={(updates) => onUpdateField(field.id, updates)}
                      onDelete={() => onDeleteField(field.id)}
                    />
                  </Box>
                ))}
            </Box>
          ) : (
            <Box
              sx={{
                p: 6,
                textAlign: "center",
                border: "2px dashed #d1d5db",
                m: 3,
                borderRadius: 2,
              }}
              data-testid="drop-zone-placeholder"
            >
              <IconButton
                disableRipple
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  color: "gray",
                }}
              >
                <AddIcon sx={{ fontSize: 48, mb: 1 }} />
              </IconButton>
              <Typography variant="h6" color="text.secondary" sx={{ mb: 1 }}>
                Drag fields here to build your form
              </Typography>
              <Typography variant="body2" color="text.secondary">
                Or click on any field from the palette to add it
              </Typography>
            </Box>
          )}
        </Paper>
      </Box>
    </Box>
  );
}
